import styled from 'styled-components';

const StyledCustomLabelWrapper = styled.div`
  width: ${props => props?.$styles?.labelWidth || '100%'};
  height: ${props => props?.$styles?.labelHeight || '14px'};
  padding-bottom: ${props => props?.$styles?.labelPaddingBottom || '3px'};

  display: flex;
  align-items: center;

  color: '#595656';
  font-size: '12px';
  font-weight: '500';
`;

export default StyledCustomLabelWrapper;
